/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'header';
const componentName = 'avi-main-header-user-card';
const prefix = `${moduleName}.${componentName}`;

export const lastLoginLabel = `${prefix}.lastLoginLabel`;
export const myAccountLabel = `${prefix}.myAccountLabel`;
export const generateTokenLabel = `${prefix}.generateTokenLabel`;

export const ENGLISH = {
    [lastLoginLabel]: 'Last Login {0}',
    [myAccountLabel]: 'My Account',
    [generateTokenLabel]: 'Generate Token',
};
